import Alert from './Alert';

export default Alert;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/alert/index.js
// module id = 330
// module chunks = 0